import { useQuery } from "react-query";
import { getSpecificationTypes } from "../../Services/SpecificationTypes";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo, useState } from "react";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import CustomPagination from "../../shared/CustomPagination";
import { useNavigate } from "react-router-dom";
import DeleteSpecificationModal from "../Specifications/DeleteSpecificationModal";
import DeleteModal from "./DeleteModal";

const tableHeader = [
  "S. No",
  "Category",
  "Specification Type Name",
  "Specifications",
  "Actions",
];

const TableHeaderComponent = () => {
  return (
    <TableHead>
      <TableRow>
        {tableHeader.map((item, idx) => {
          return (
            <TableCell
              className="!font-semibold border-2 !border-slate-200"
              align="center"
              key={idx}
            >
              {item}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

const SpecificationTypeTable = ({ search, setIsModalOpen, setRowData }) => {
  const [page, setPage] = useState(1);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState();
  const navigate = useNavigate();
  const { data: specificationTypeData } = useQuery(
    ["specificationTypes", search, page],
    () => getSpecificationTypes({ search, page }),
  );

  const specificationTypes = useMemo(
    () => specificationTypeData?.data?.data,
    [specificationTypeData],
  );

  return (
    <>
      <TableContainer component={Paper} className="!bg-white">
        <Table>
          <TableHeaderComponent />
          <TableBody>
            {specificationTypes?.map(
              (
                { id, specification_name, category_name, maincategory },
                idx,
              ) => {
                return (
                  <TableRow key={idx}>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {idx + 1 + (page - 1) * 10}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {category_name}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      {specification_name}
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      <Visibility
                        className="text-gray-600 cursor-pointer"
                        onClick={() => navigate(`/specification-type/${id}`)}
                      />
                    </TableCell>
                    <TableCell
                      className="border-2 !border-slate-200"
                      align="center"
                    >
                      <div className="flex flex-row justify-center gap-2">
                        <Edit
                          className="text-green-500 cursor-pointer"
                          onClick={() => {
                            setRowData({
                              maincategory,
                              id,
                              specification_name,
                            });
                            setIsModalOpen(true);
                          }}
                        />
                        <Delete
                          className="text-red-500 cursor-pointer"
                          onClick={() => {
                            setIsDeleteModalOpen(true);
                            setIdToDelete(id);
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              },
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DeleteModal
        open={isDeleteModalOpen}
        setOpen={setIsDeleteModalOpen}
        id={idToDelete}
      />
      <CustomPagination data={specificationTypeData} setPage={setPage} />
    </>
  );
};

export default SpecificationTypeTable;
